/* eslint-disable import/no-unresolved */
import React from 'react'

import { Tooltip, IconButton } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'

import { PencilIcon } from 'components/icons/personalizedIcons'

const UpdateEmailSeller = ({ updateEmailSeller, setShowInputEmail, showInputEmail }) => {
  return (
    <>
      {showInputEmail ? (
        <>
          <Tooltip title="Actualizar">
            <IconButton
              onClick={() => {
                updateEmailSeller()
              }}
            >
              <CheckIcon
                style={{
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: 'green',
                }}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancelar">
            <IconButton
              onClick={() => {
                setShowInputEmail(!showInputEmail)
              }}
            >
              <CloseIcon
                style={{
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: 'red',
                }}
              />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              setShowInputEmail(!showInputEmail)
            }}
          >
            <PencilIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  )
}

export default UpdateEmailSeller
